/*
 * Grocera – ca aplicația (tema de test, 03.10.2026). Ce face site-ul pe telefon ca aplicația, în afară de aspect
 * (assets/grocera-ca-aplicatia.css) și de bare (snippets/grocera-bara-jos.liquid, grocera-bara-sus.liquid):
 * - bara de jos: urcă deasupra barei de previzualizare Shopify, se ascunde cât scrii;
 * - bara de sus: înapoi, trimite, „Golește” coșul (fără inimă: favoritele nu mai sunt pe site, 04.10.2026);
 * - raionul: fiecare subcategorie cu toate produsele (pe măsură ce te apropii de ea), pastilele lipite sus, cea
 *   curentă verde; deschis la o subcategorie (#subcol-…), încarcă întâi tot ce e deasupra ei, apoi sare acolo;
 * - prima pagină și capătul raionului: pozele pătrate ale raioanelor din aplicație; căutarea cu textul aplicației;
 * - produsul: descrierea pliată;
 * - coșul: pragul sus (bara spre comanda minimă, apoi spre livrarea gratuită), butonul de plată jos, cu textul
 *   aplicației („Comanda minimă: 50,00 RON”, „Alege intervalul de livrare”, „Continuă spre plată · …”), zilele și
 *   orele de livrare direct în coș (nu în pop-up), „Garanție SGR” și coșul gol ca în aplicație.
 * Doar sub 768 px și nu în aplicația veche (Natively): acolo nu face nimic.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  if (root.classList.contains('ga-natively')) return;
  var phone = window.matchMedia('(max-width: 767px)');
  var data = {};
  try {
    var node = document.getElementById('GaData');
    if (node) data = JSON.parse(node.textContent || '{}');
  } catch (error) {
    data = {};
  }

  /*
   * Coșul ca în aplicație (Zoli, 04.10.2026): adresele, zilele și orele de livrare direct în coș, nu după butonul
   * „Alege intervalul”. Widgetul de livrare (grocera-routes, blocul „Grocera · livrare”) are ambele moduri; tema asta,
   * copiată din cea live, are pornit „Intervalele într-un pop-up”. Pe telefon îl stingem aici, înainte să pornească
   * widgetul: scripturile `defer` rulează în ordinea din pagină, iar al nostru (din bara de jos) e înaintea lui, după
   * setările lui (`window.GroceraLivrare`, scrise în pagină). Pe calculator rămâne cum e setat în temă.
   */
  if (phone.matches && window.GroceraLivrare) window.GroceraLivrare.slotPopup = false;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  /** Spațiul care nu se rupe, ca „50,00 RON” să nu se despartă pe două rânduri. */
  var NBSP = String.fromCharCode(160);

  /** „1.234,50 RON” → 1234.5 (prețurile temei). */
  function lei(text) {
    var clean = String(text || '').replace(/[^0-9,.-]/g, '').replace(/[.]/g, '').replace(',', '.');
    var value = parseFloat(clean);
    return isNaN(value) ? null : value;
  }

  /** 50 → „50,00 RON”, ca în aplicație (1234,5 → „1.234,50 RON”). */
  function bani(value) {
    var fixed = value.toFixed(2).split('.');
    var whole = fixed[0];
    var groups = '';
    while (whole.length > 3) {
      groups = '.' + whole.slice(-3) + groups;
      whole = whole.slice(0, -3);
    }
    return whole + groups + ',' + fixed[1] + NBSP + 'RON';
  }

  /* ───────── Bara de jos ───────── */

  // Bara de previzualizare Shopify (doar când se previzualizează tema): bara noastră stă deasupra ei.
  function previewLift() {
    var preview = document.getElementById('PBarNextFrameWrapper');
    var lift = 0;
    if (preview) {
      var box = preview.getBoundingClientRect();
      if (box.height > 0 && box.bottom >= window.innerHeight - 2) lift = Math.max(0, Math.round(window.innerHeight - box.top));
    }
    root.style.setProperty('--ga-preview-bar', lift + 'px');
  }
  var watchedPreview = null;
  function watchPreview() {
    var preview = document.getElementById('PBarNextFrameWrapper');
    if (preview && preview !== watchedPreview && 'ResizeObserver' in window) {
      watchedPreview = preview;
      new ResizeObserver(previewLift).observe(preview);
    }
    previewLift();
  }

  // Cât scrii (căutarea, un formular), bara de jos iese din cale, ca în aplicație: altfel, pe Android, stă peste tastatură.
  function isTyping(el) {
    return !!el && !!el.matches && el.matches('input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]):not([type=hidden]), textarea, select, [contenteditable="true"]');
  }
  document.addEventListener('focusin', function (event) {
    if (isTyping(event.target)) root.classList.add('ga-typing');
  });
  document.addEventListener('focusout', function () {
    setTimeout(function () {
      if (!isTyping(document.activeElement)) root.classList.remove('ga-typing');
    }, 60);
  });

  /* ───────── Bara de sus ───────── */

  function goBack(fallback) {
    var sameSite = false;
    try {
      sameSite = !!document.referrer && new URL(document.referrer).host === location.host;
    } catch (error) {
      sameSite = false;
    }
    if (sameSite && history.length > 1) history.back();
    else location.href = fallback || '/';
  }

  function topbar() {
    var bar = document.getElementById('GaTopbar');
    if (!bar) return;
    bar.addEventListener('click', function (event) {
      var back = event.target.closest('[data-ga-back]');
      if (back) {
        event.preventDefault();
        if (onProduct) sheetSignal('inchide');
        goBack(back.getAttribute('href'));
        return;
      }
      if (event.target.closest('[data-ga-share]')) {
        event.preventDefault();
        share();
        return;
      }
      if (event.target.closest('[data-ga-empty]')) {
        event.preventDefault();
        emptyCart();
      }
    });
  }

  function share() {
    if (navigator.share) {
      navigator.share({ title: document.title, url: location.href.split('#')[0] }).catch(function () {});
      return;
    }
    // Fără „Trimite” al telefonului: fereastra „Distribuie” a temei (linkurile de rețele și copierea).
    var themeShare = document.querySelector('.product__block--addons button');
    if (themeShare) themeShare.click();
  }

  function emptyCart() {
    if (!window.confirm('Golești coșul? Toate produsele ies din coș.')) return;
    var clearUrl = window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_clear_url ? FoxTheme.routes.cart_clear_url : '/cart/clear';
    fetch(clearUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    })
      .catch(function () {})
      .then(function () {
        location.reload();
      });
  }

  /* ───────── Raionul: toate produsele, pe subcategorii ───────── */

  var PAGE = 50;

  function rowState(row) {
    var carousel = row.querySelector('subcol-row-carousel');
    if (!carousel) return null;
    if (!carousel._ga) {
      carousel._ga = {
        url: carousel.getAttribute('data-collection-url'),
        total: parseInt(carousel.getAttribute('data-total'), 10) || 0,
        promise: null,
      };
    }
    return carousel._ga;
  }

  // Toate produsele unei colecții, câte 50 (Section Rendering API, secțiunea temei `api-collection-chain`), cel mult 6 pagini.
  function chainColumns(url, total) {
    var pages = Math.min(6, Math.max(1, Math.ceil(total / PAGE)));
    var requests = [];
    for (var page = 1; page <= pages; page++) {
      requests.push(
        fetch(url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=api-collection-chain&page=' + page, { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .catch(function () {
            return '';
          }),
      );
    }
    return Promise.all(requests).then(function (htmls) {
      var columns = [];
      htmls.forEach(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        each(doc.querySelectorAll('[data-chain-items] > .product-column'), function (column) {
          columns.push(column);
        });
      });
      return columns;
    });
  }

  function productKey(node) {
    var link = node.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href').split('?')[0] : null;
  }

  // Coloana din răspuns, ca element al rândului (cardurile își fac singure butonul de coș la inserare).
  function rowItem(column) {
    var item = document.createElement('div');
    item.className = 'subcol-row__product-item swiper-slide';
    // Copia coloanei, apoi copiii ei mutați în element (appendChild îi scoate din copie, deci bucla se oprește).
    var copy = document.importNode(column, true);
    while (copy.firstChild) item.appendChild(copy.firstChild);
    return item;
  }

  // Sub-subcategoriile subcategoriei de pe rând (GaData.copii, din snippets/grocera-bara-sus.liquid), sau nimic.
  function rowKids(row) {
    var id = row.getAttribute('data-ga-id') || row.id || '';
    var kids = (data.copii || {})[id.replace(/^(ga-)?subcol-/, '')];
    return kids && kids.length ? kids : null;
  }

  /*
   * Rândurile de după primele trei vin „adormite” (assets/subcol-defer.js): cele zece carduri ale lor sunt scoase din
   * pagină și puse la loc abia când te apropii (la 900 px). Noi umplem rândul mai devreme (la 1400 px), deci le punem
   * noi la loc întâi. Altfel, la trezire, cele zece se adăugau a doua oară, la capătul rândului deja plin.
   */
  function wakeRow(row) {
    var carousel = row.querySelector('subcol-row-carousel');
    if (!carousel || !carousel._deferStash) return;
    var box = carousel.querySelector('.subcol-row__products');
    if (box) {
      carousel._deferStash.forEach(function (node) {
        box.appendChild(node);
      });
    }
    carousel._deferStash = null;
    carousel.style.minHeight = '';
    carousel.removeAttribute('data-subcol-deferred');
    delete carousel._init;
    delete carousel._initLazyLoad;
  }

  function fillRow(row) {
    var state = rowState(row);
    if (!state || !state.url) return Promise.resolve();
    if (state.promise) return state.promise;
    wakeRow(row);
    var list = row.querySelector('.subcol-row__products');
    var kids = rowKids(row);
    if (list && kids) {
      state.promise = fillRowKids(row, list, state, kids);
      return state.promise;
    }
    var shown = list ? list.querySelectorAll('.subcol-row__product-item').length : 0;
    if (!list || state.total <= shown) {
      state.promise = Promise.resolve();
      return state.promise;
    }
    row.classList.add('ga-row--loading');
    state.promise = chainColumns(state.url, state.total).then(function (columns) {
      var seen = {};
      each(list.querySelectorAll('.subcol-row__product-item'), function (item) {
        var key = productKey(item);
        if (key) seen[key] = true;
      });
      var fragment = document.createDocumentFragment();
      columns.forEach(function (column) {
        var key = productKey(column);
        if (!key || seen[key]) return;
        seen[key] = true;
        fragment.appendChild(rowItem(column));
      });
      list.appendChild(fragment);
      row.classList.remove('ga-row--loading');
    });
    return state.promise;
  }

  /*
   * Al treilea nivel, ca în aplicație (Zoli, 04.10.2026: „integrează și pe mobil sub-subcategoriile, că pe desktop le-ai
   * pus și pe mobil nu”): o subcategorie cu sub-subcategorii (Brânzeturi → Telemea, Caș & Burduf…) își arată produsele
   * pe ele, fiecare cu titlul ei, ca în aplicație (`fetchSectionGroups`); ce nu e în niciuna vine la capăt, la „Alte
   * produse”. Care sunt acelea aflăm din id-urile subcategoriei (sections/ga-produse-id.liquid, o cerere mică), iar
   * cardurile lor se cer doar dacă există. Sub pastilele raionului apare rândul pastilelor ei (`showSubBar`).
   */
  function columnId(column) {
    return column.getAttribute('data-pid') || productKey(column);
  }

  function collectionIds(url) {
    return fetch(url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=ga-produse-id', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ga-produse-id]');
        if (!node) return null;
        var raw = node.getAttribute('data-ga-produse-id') || '';
        return raw ? raw.split(',') : [];
      })
      .catch(function () {
        return null;
      });
  }

  function fillRowKids(row, list, state, kids) {
    row.classList.add('ga-row--loading');
    var kidRequests = kids.map(function (kid) {
      return chainColumns(kid.u, kid.n);
    });
    return Promise.all([Promise.all(kidRequests), collectionIds(state.url)])
      .then(function (loaded) {
        var results = loaded[0];
        var ownIds = loaded[1];
        var inKids = {};
        results.forEach(function (columns) {
          columns.forEach(function (column) {
            var id = columnId(column);
            if (id) inKids[id] = true;
          });
        });
        // „Alte produse”: doar dacă subcategoria are produse în afara copiilor (fără id-uri, le cerem pe toate, ca aplicația).
        var restIds = null;
        if (ownIds) {
          restIds = {};
          var missing = 0;
          ownIds.forEach(function (id) {
            if (!inKids[id]) {
              restIds[id] = true;
              missing++;
            }
          });
          if (!missing) return { results: results, rest: [] };
        }
        return chainColumns(state.url, state.total).then(function (own) {
          return {
            results: results,
            rest: own.filter(function (column) {
              var id = columnId(column);
              return id && !inKids[id] && (!restIds || restIds[id]);
            }),
          };
        });
      })
      .then(function (loaded) {
        var groups = [];
        kids.forEach(function (kid, i) {
          var seen = {};
          var items = [];
          loaded.results[i].forEach(function (column) {
            var id = columnId(column);
            if (!id || seen[id]) return;
            seen[id] = true;
            items.push(rowItem(column));
          });
          if (items.length) groups.push({ kid: kid, items: items });
        });
        // Copiii n-au venit deloc (rețea): rămân produsele subcategoriei, ca până acum.
        if (!groups.length) {
          state.promise = null;
          row.classList.remove('ga-row--loading');
          data.copii[(row.getAttribute('data-ga-id') || '').replace(/^subcol-/, '')] = null;
          return fillRow(row);
        }
        var restSeen = {};
        var rest = [];
        loaded.rest.forEach(function (column) {
          var id = columnId(column);
          if (!id || restSeen[id]) return;
          restSeen[id] = true;
          rest.push(rowItem(column));
        });
        var fragment = document.createDocumentFragment();
        var heading = function (text, handle) {
          var h = document.createElement('h3');
          h.className = 'ga-subsub__titlu';
          if (handle) h.setAttribute('data-ga-subsub', handle);
          h.textContent = text;
          return h;
        };
        groups.forEach(function (group) {
          fragment.appendChild(heading(group.kid.t, group.kid.h));
          group.items.forEach(function (item) {
            fragment.appendChild(item);
          });
        });
        if (rest.length) {
          fragment.appendChild(heading('Alte produse', ''));
          rest.forEach(function (item) {
            fragment.appendChild(item);
          });
        }
        while (list.firstChild) list.removeChild(list.firstChild);
        list.appendChild(fragment);
        state.kids = groups.map(function (group) {
          return group.kid;
        });
        row.classList.add('ga-row--copii');
        row.classList.remove('ga-row--loading');
        if (onRowKids) onRowKids(row);
      });
  }
  var onRowKids = null;

  function raion() {
    var rows = Array.prototype.slice.call(document.querySelectorAll('.subcol-row'));
    if (!rows.length) return;
    root.classList.add('ga-raion');
    var strip = document.querySelector('.subcategory-tabs-wrapper:not(.sibling-tabs-wrapper)');
    var tabs = strip ? Array.prototype.slice.call(strip.querySelectorAll('.subcategory-tab[href^="#"]')) : [];

    // Scriptul temei își alege pastila după id-ul rândurilor, cu alte distanțe decât ale noastre (și ar sări între
    // două pastile). Cu id-urile schimbate nu mai găsește nimic și ne lasă pe noi; adresa rămâne #subcol-….
    rows.forEach(function (row) {
      row.setAttribute('data-ga-id', row.id);
      row.id = 'ga-' + row.id;
    });
    function rowFor(id) {
      for (var i = 0; i < rows.length; i++) if (rows[i].getAttribute('data-ga-id') === id) return rows[i];
      return null;
    }

    function topOffset() {
      var bar = document.getElementById('GaTopbar');
      return (bar ? bar.offsetHeight : 0) + (strip ? strip.offsetHeight : 0) + 8;
    }

    // Al treilea nivel: pastilele sub-subcategoriilor, sub pastilele raionului, cât e pe ecran o subcategorie care le
    // are (ca `SubTabs` din aplicație). În pagină are înălțimea zero: când apare sau dispare, nu mută nimic sub deget.
    var subBar = null;
    var subRow = null;
    var subActive = null;
    if (strip && data.copii) {
      subBar = document.createElement('div');
      subBar.className = 'ga-subsub-bara';
      subBar.hidden = true;
      var subLine = document.createElement('div');
      subLine.className = 'ga-subsub-bara__rand';
      subBar.appendChild(subLine);
      strip.parentNode.insertBefore(subBar, strip.nextSibling);
      var syncStrip = function () {
        root.style.setProperty('--ga-strip-h', strip.offsetHeight + 'px');
      };
      syncStrip();
      if ('ResizeObserver' in window) new ResizeObserver(syncStrip).observe(strip);
      subBar.addEventListener('click', function (event) {
        var pill = event.target.closest && event.target.closest('[data-ga-subsub]');
        if (!pill || !subRow) return;
        event.preventDefault();
        var handle = pill.getAttribute('data-ga-subsub');
        var head = subRow.querySelector('.ga-subsub__titlu[data-ga-subsub="' + handle + '"]');
        if (!head) return;
        quietUntil = Date.now() + 900;
        setSubActive(handle, true);
        var top = head.getBoundingClientRect().top + window.scrollY - topOffset() - subBarHeight() + 4;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    }
    function subBarHeight() {
      return subBar && !subBar.hidden ? subBar.firstChild.offsetHeight || 0 : 0;
    }
    function showSubBar(row) {
      if (!subBar) return;
      var state = row ? rowState(row) : null;
      var kids = state && state.kids;
      if (!kids || !kids.length) {
        subBar.hidden = true;
        subRow = null;
        subActive = null;
        return;
      }
      if (subRow === row && !subBar.hidden) return;
      subRow = row;
      subActive = null;
      var line = subBar.firstChild;
      while (line.firstChild) line.removeChild(line.firstChild);
      kids.forEach(function (kid) {
        var pill = document.createElement('a');
        pill.className = 'subcategory-tab';
        pill.href = kid.u;
        pill.setAttribute('data-ga-subsub', kid.h);
        pill.textContent = kid.t;
        line.appendChild(pill);
      });
      subBar.hidden = false;
      line.scrollLeft = 0;
    }
    function setSubActive(handle, smooth) {
      if (!subBar || handle === subActive) return;
      subActive = handle;
      var line = subBar.firstChild;
      each(line.querySelectorAll('[data-ga-subsub]'), function (pill) {
        var on = pill.getAttribute('data-ga-subsub') === handle;
        pill.classList.toggle('ga-on', on);
        if (on) {
          var left = pill.offsetLeft - (line.clientWidth - pill.offsetWidth) / 2;
          line.scrollTo({ left: Math.max(0, left), behavior: smooth ? 'smooth' : 'auto' });
        }
      });
    }
    // Rândul unei subcategorii cu copii s-a umplut: dacă e cel de pe ecran, apar și pastilele lui.
    onRowKids = function (row) {
      if (row.getAttribute('data-ga-id') === activeId) {
        subRow = null;
        showSubBar(row);
      }
    };
    function scrollToRow(row, smooth) {
      // Cu pastilele sub-subcategoriilor deasupra (apar odată cu rândul), titlul lui nu trebuie să ajungă sub ele.
      var state = rowState(row);
      var under = state && state.kids && state.kids.length ? 46 : 0;
      var top = row.getBoundingClientRect().top + window.scrollY - topOffset() - under;
      window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
    }

    var activeId = null;
    function setActive(id, smooth) {
      if (id === activeId) return;
      activeId = id;
      showSubBar(rowFor(id));
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('href') === '#' + id;
        tab.classList.toggle('ga-on', on);
        if (on) tab.setAttribute('aria-current', 'true');
        else tab.removeAttribute('aria-current');
        if (on && strip) {
          var left = tab.offsetLeft - (strip.clientWidth - tab.offsetWidth) / 2;
          strip.scrollTo({ left: Math.max(0, left), behavior: smooth ? 'smooth' : 'auto' });
        }
      });
    }

    // Deschis la o subcategorie (#subcol-…): întâi tot ce e deasupra ei, ca pagina să nu mai fugă, apoi acolo.
    var target = null;
    if (location.hash && /^#subcol-/.test(location.hash)) target = rowFor(decodeURIComponent(location.hash.slice(1)));
    var lazyFrom = 0;
    var quietUntil = 0;
    if (target) {
      var index = rows.indexOf(target);
      lazyFrom = index + 1;
      root.classList.add('ga-raion--jumping');
      quietUntil = Date.now() + 60000;
      setActive(target.getAttribute('data-ga-id'), false);
      Promise.all(rows.slice(0, index + 1).map(fillRow)).then(function () {
        pin(target);
      });
    }

    // Subcategoria aleasă rămâne sub pastile cât se mai așază pagina (scripturile temei, pozele), până pune omul
    // degetul pe ecran sau trec 2,5 secunde.
    function pin(row) {
      var until = Date.now() + 2500;
      var stopped = false;
      var stop = function () {
        stopped = true;
      };
      ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (type) {
        window.addEventListener(type, stop, { once: true, passive: true });
      });
      var align = function () {
        if (!stopped) scrollToRow(row, false);
      };
      align();
      root.classList.remove('ga-raion--jumping');
      var watcher = 'ResizeObserver' in window ? new ResizeObserver(align) : null;
      if (watcher) {
        rows.slice(0, rows.indexOf(row) + 1).forEach(function (r) {
          watcher.observe(r);
        });
      }
      (function tick() {
        if (stopped || Date.now() > until) {
          if (watcher) watcher.disconnect();
          quietUntil = Date.now() + 300;
          return;
        }
        align();
        setTimeout(tick, 150);
      })();
    }

    // Restul se încarcă pe măsură ce te apropii (dedesubt), deci nimic nu se mișcă deasupra ecranului.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              fillRow(entry.target);
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px 1400px 0px' },
      );
      rows.slice(lazyFrom).forEach(function (row) {
        io.observe(row);
      });
    } else {
      rows.forEach(fillRow);
    }

    // Pastilele duc la subcategorie (încărcând tot ce e până la ea). Faza de captură: scriptul temei nu mai apucă.
    document.addEventListener(
      'click',
      function (event) {
        var tab = event.target.closest && event.target.closest('.subcategory-tabs-wrapper:not(.sibling-tabs-wrapper) .subcategory-tab[href^="#"]');
        if (!tab || !phone.matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var id = tab.getAttribute('href').slice(1);
        var row = rowFor(id);
        if (!row) return;
        quietUntil = Date.now() + 60000;
        setActive(id, true);
        if (history.replaceState) history.replaceState(history.state, '', '#' + id);
        var i = rows.indexOf(row);
        Promise.all(rows.slice(0, i + 1).map(fillRow)).then(function () {
          scrollToRow(row, true);
          quietUntil = Date.now() + 900;
        });
      },
      true,
    );

    // Pastila verde arată unde ești, ca în aplicație.
    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          if (Date.now() < quietUntil || !phone.matches) return;
          var line = topOffset() + 40;
          var current = rows[0];
          for (var r = 0; r < rows.length; r++) {
            if (rows[r].getBoundingClientRect().top <= line) current = rows[r];
            else break;
          }
          if (current) setActive(current.getAttribute('data-ga-id'), true);
          if (subRow && !subBar.hidden) {
            var subLine = line + subBarHeight();
            var heads = subRow.querySelectorAll('.ga-subsub__titlu[data-ga-subsub]');
            var pick = heads.length ? heads[0].getAttribute('data-ga-subsub') : null;
            for (var h = 0; h < heads.length; h++) {
              if (heads[h].getBoundingClientRect().top <= subLine) pick = heads[h].getAttribute('data-ga-subsub');
              else break;
            }
            if (pick) setSubActive(pick, true);
          }
        });
      },
      { passive: true },
    );
    if (!target) setActive(rows[0].getAttribute('data-ga-id'), false);
  }

  /* ───────── Pozele raioanelor ───────── */

  // Scurtăturile de pe prima pagină și „Continuă cu” de la capătul raionului: pozele pătrate ale aplicației.
  function squareImages() {
    var map = data.patrat || {};
    each(document.querySelectorAll('a.collection-card__wrapper[href*="/collections/"], a.chain-more__card[href*="/collections/"]'), function (card) {
      var handle = decodeURIComponent((card.getAttribute('href') || '').split('/collections/')[1] || '').split(/[?#/]/)[0];
      var url = map[handle];
      if (!url) return;
      var img = card.querySelector('.collection-card__image img, .chain-more__img img');
      if (!img || img.classList.contains('ga-app-img')) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', url);
      img.classList.add('ga-app-img');
    });
  }

  /* ───────── Căutarea ───────── */

  function searchPlaceholder() {
    var text = window.innerWidth >= 375 ? 'Ce cauți? Produs, categorie, brand' : 'Caută produs, categorie, brand';
    each(document.querySelectorAll('.header__search .search__input'), function (input) {
      input.setAttribute('placeholder', text);
    });
  }

  /* ───────── Produsul ───────── */

  function product() {
    if (!document.querySelector('.section-main-product')) return;
    // Descrierea, pliată ca în aplicație: se deschide la apăsare.
    each(document.querySelectorAll('.product__block--description[class~="md:hidden"]'), function (block) {
      var heading = block.querySelector('.product__description-heading');
      if (!heading || block.classList.contains('ga-fold')) return;
      block.classList.add('ga-fold');
      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      heading.setAttribute('aria-expanded', 'false');
      var toggle = function () {
        var open = block.classList.toggle('is-open');
        heading.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      heading.addEventListener('click', toggle);
      heading.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
    });
  }

  /* ───────── Coșul ───────── */

  // Bara pragului, ca în aplicație: întâi spre comanda minimă (galbenă), apoi spre livrarea gratuită (verde).
  function goalBar(goal) {
    var track = goal.querySelector('.cart-goal__track');
    if (!track) return null;
    var now = parseFloat(track.getAttribute('aria-valuenow')) || 0;
    var max = parseFloat(track.getAttribute('aria-valuemax')) || 0;
    var tick = goal.querySelector('.cart-goal__tick:not(.cart-goal__tick--end)');
    var minShare = tick ? parseFloat(tick.style.left || tick.style.insetInlineStart || '0') : 0;
    var min = Math.round((max * minShare) / 100);
    var below = min > 0 && now < min;
    var target = below ? min : max;
    var share = target > 0 ? Math.min(100, (now / target) * 100) : 100;
    goal.style.setProperty('--ga-goal', share.toFixed(2) + '%');
    goal.classList.toggle('ga-goal--below', below);
    goal.classList.toggle('ga-goal--done', !below && max > 0 && now >= max);
    var message = goal.querySelector('.cart-goal__message');
    if (below && message && !message.querySelector('.ga-goal__min')) {
      var minText = document.createElement('span');
      minText.className = 'ga-goal__min';
      minText.textContent = ' (minim ' + bani(min / 100) + ')';
      var text = message.lastChild;
      var end = text && text.nodeType === 3 ? (text.nodeValue.trimEnd ? text.nodeValue.trimEnd() : text.nodeValue) : '';
      // „…ca să poți comanda.” → „…ca să poți comanda (minim 50,00 RON).”
      if (end.slice(-1) === '.') {
        text.nodeValue = end.slice(0, -1);
        message.appendChild(minText);
        message.appendChild(document.createTextNode('.'));
      } else {
        message.appendChild(minText);
      }
    }
    return { below: below, min: min };
  }

  function cart() {
    var main = document.querySelector('main-cart');
    if (!main) return;
    root.classList.add('ga-cart');
    var busy = false;
    var place = function () {
      if (busy) return;
      busy = true;
      // Pragul sus, deasupra produselor. Tema reface coșul la fiecare schimbare, deci îl mutăm din nou.
      var fresh = main.querySelector('.cart__footer .cart-goal');
      var inner = main.querySelector('.cart__inner');
      // Coșul gol n-are prag (nici în aplicație): rămâne ascuns, cu tot cu subsolul temei.
      if (main.querySelector('.cart__footer.hidden')) {
        each(main.querySelectorAll('.ga-goal'), function (old) {
          old.remove();
        });
        fresh = null;
      }
      if (fresh && inner) {
        each(main.querySelectorAll('.ga-goal'), function (old) {
          if (old !== fresh) old.remove();
        });
        fresh.classList.add('ga-goal');
        inner.parentNode.insertBefore(fresh, inner);
      }
      var goal = main.querySelector('.ga-goal');
      var state = goal ? goalBar(goal) : null;
      checkoutLabel(main, state);
      sgrRow(main);
      busy = false;
    };
    place();
    emptyCartTexts();
    // Sub coș, ofertele au titlul din aplicație.
    each(document.querySelectorAll('[id*="__featured_collection"] .section__header *'), function (el) {
      if (el.children.length === 0 && el.textContent.trim() === 'Oferte pe care să nu le ratezi') {
        el.textContent = 'Completează-ți coșul cu produse reduse';
      }
    });
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var target = records[i].target;
        if (target.nodeType === 1 && target.closest && target.closest('.ga-goal')) continue;
        place();
        return;
      }
    }).observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });
  }

  // Coșul gol, cu textele din aplicație („Coșul e gol”, „Începe cumpărăturile”).
  function emptyCartTexts() {
    var box = document.querySelector('.cart.is-empty .cart__empty');
    if (!box || box.classList.contains('ga-gol')) return;
    box.classList.add('ga-gol');
    var title = box.querySelector('div.cart__empty-header .h1');
    if (title) title.textContent = 'Coșul e gol';
    var text = box.querySelector('div.cart__empty-header .rte');
    if (text) text.textContent = 'Adaugă produse și ți le aducem acasă, în intervalul ales.';
    var button = box.querySelector('a.cart__empty-header .btn__text');
    if (button) button.textContent = 'Începe cumpărăturile';
  }

  // Garanția SGR, cu numele și explicația din aplicație: „Taxa SGR” → „Garanție SGR”, iar dedesubt de ce nu e o taxă.
  function sgrRow(main) {
    var box = main.querySelector('.cart__footer--subtotal');
    if (!box) return;
    var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null);
    var found = [];
    while (walker.nextNode()) {
      if (/Taxa SGR/.test(walker.currentNode.nodeValue)) found.push(walker.currentNode);
    }
    found.forEach(function (text) {
      text.nodeValue = text.nodeValue.replace('Taxa SGR', 'Garanție SGR');
      var row = text.parentNode;
      while (row && row.parentNode && row.parentNode !== box && !(row.parentNode.classList && row.parentNode.classList.contains('grid'))) {
        row = row.parentNode;
      }
      if (!row || !row.parentNode || (row.nextElementSibling && row.nextElementSibling.classList.contains('ga-sgr-nota'))) return;
      var note = document.createElement('div');
      note.className = 'ga-sgr-nota';
      note.textContent = 'O primești înapoi când returnezi ambalajele.';
      row.parentNode.insertBefore(note, row.nextSibling);
    });
  }

  // Butonul de plată spune, ca în aplicație, ce mai lipsește: comanda minimă, intervalul (de la widgetul de livrare)
  // sau, gata de plată, totalul.
  function checkoutLabel(main, state) {
    var button = main.querySelector('.cart__footer .gr-liv-finalizare, .cart__footer [name="checkout"]');
    if (!button) return;
    var label = button.querySelector('.btn__text') || button;
    if (!label.hasAttribute('data-ga-text')) label.setAttribute('data-ga-text', label.textContent.trim());
    var text;
    if (state && state.below) {
      text = 'Comanda minimă: ' + bani(state.min / 100);
    } else if (button.classList.contains('gr-liv-blocat')) {
      text = button.getAttribute('data-gr-liv-motiv') || 'Alege intervalul de livrare';
    } else {
      var total = main.querySelector('.totals__subtotal-value');
      var value = total ? lei(total.textContent) : null;
      text = 'Continuă spre plată' + (value != null ? NBSP + '·' + NBSP + bani(value) : '');
    }
    if (label.textContent !== text) label.textContent = text;
    // Gata de plată: lacătul din aplicație înaintea textului. Sub comanda minimă, butonul e stins, ca în aplicație.
    var gata = text.indexOf('Continuă spre plată') === 0;
    var below = !!(state && state.below);
    if (button.classList.contains('ga-plata-gata') !== gata) button.classList.toggle('ga-plata-gata', gata);
    if (button.classList.contains('ga-plata-minim') !== below) button.classList.toggle('ga-plata-minim', below);
  }

  /* ───────── Pornire ───────── */

  /* ───────── Produsul ca o foaie (a cincea rundă, 04.10.2026) ───────── */

  /*
   * Zoli: „când dai pe un produs, pagina de produs să fie tot așa, dar să aibă feel de quick view, cum e și în apk”.
   * Pagina produsului rămâne pagina produsului; doar urcă de jos ca o foaie peste pagina de dinainte și coboară la X,
   * lăsând-o la loc, la aceeași derulare. Trecerea o face browserul (view transitions între pagini: iPhone cu iOS 18.2+,
   * Chrome pe Android), pornită din layout/theme.liquid (scriptul din <head>, „ga-foaie”) după semnul lăsat aici:
   * „deschide” la apăsarea pe un produs, „închide” la X. Fără semn (înapoi din browser, alte linkuri), nicio trecere.
   */
  var onProduct = /^\/products\//.test(location.pathname);
  function sheetSignal(kind) {
    try {
      sessionStorage.setItem('ga-foaie', JSON.stringify({ tip: kind, la: Date.now() }));
    } catch (error) {
      /* Fără sessionStorage: pagina se deschide ca până acum. */
    }
  }
  function productSheet() {
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link || (link.target && link.target !== '_self')) return;
      var url;
      try {
        url = new URL(link.href, location.href);
      } catch (error) {
        return;
      }
      if (url.origin !== location.origin || !/^\/products\//.test(url.pathname) || url.pathname === location.pathname) return;
      sheetSignal('deschide');
      if (!onProduct) rememberPlace(link);
    });
    // Plecat de aici altfel decât spre un produs: locul ținut minte nu mai e al întoarcerii de acum.
    window.addEventListener('pagehide', function () {
      if (placeSaved) return;
      try {
        var saved = JSON.parse(sessionStorage.getItem(PLACE_KEY) || 'null');
        if (saved && saved.url === location.pathname + location.search) sessionStorage.removeItem(PLACE_KEY);
      } catch (error) {}
    });
  }

  /*
   * A șaptea rundă (04.10.2026, Zoli: „când deschid un produs pe home page și după dau X, se mișcă execrabil”): la
   * întoarcere, browserul reîncarcă pagina de dinainte și o arăta întâi de sus, apoi sărea. Ținem minte produsul apăsat:
   * linkul lui (al câtelea, dacă apare de mai multe ori), cât de sus era pe ecran, cât era derulată pagina și secțiunea
   * de după el. Scriptul din <head> (layout/theme.liquid, „ga-foaie”) pune pagina la loc înainte să se vadă.
   */
  var PLACE_KEY = 'ga-foaie-loc';
  var placeSaved = false;
  function rememberPlace(link) {
    try {
      var href = link.getAttribute('href');
      var same = 0;
      var nth = 0;
      var all = document.querySelectorAll('a[href]');
      for (var i = 0; i < all.length; i++) {
        if (all[i].getAttribute('href') !== href) continue;
        if (all[i] === link) nth = same;
        same++;
      }
      // Secțiunea de după cea de după produs: la întoarcere, pagina se desenează abia când a ajuns acolo, deci are
      // și conținut sub produs, cât un ecran.
      var section = link.closest('.shopify-section');
      var after = section ? section.nextElementSibling : null;
      while (after && !after.id) after = after.nextElementSibling;
      var further = after ? after.nextElementSibling : null;
      while (further && !further.id) further = further.nextElementSibling;
      if (further) after = further;
      var box = link.getBoundingClientRect();
      sessionStorage.setItem(
        PLACE_KEY,
        JSON.stringify({
          url: location.pathname + location.search,
          href: href,
          nr: nth,
          sus: Math.round(box.top),
          y: Math.round(window.scrollY),
          dupa: after ? after.id : null,
          la: Date.now(),
        }),
      );
      placeSaved = true;
    } catch (error) {
      /* Fără sessionStorage: întoarcerea rămâne a browserului, ca până acum. */
    }
  }

  // Produsul se deschide „peste” tabul de unde vii, ca în aplicație: din Acasă rămâne aleasă Acasă, din Coș, Coș.
  function originTab() {
    var bar = document.getElementById('GaTabbar');
    if (!bar) return;
    var tabs = bar.querySelectorAll('.ga-tab');
    var current = bar.querySelector('.ga-tab.is-current');
    var index = Array.prototype.indexOf.call(tabs, current);
    if (!onProduct) {
      try {
        if (index >= 0) sessionStorage.setItem('ga-tab', String(index));
      } catch (error) {}
      return;
    }
    var saved = null;
    try {
      saved = sessionStorage.getItem('ga-tab');
    } catch (error) {
      saved = null;
    }
    var target = saved != null ? tabs[Number(saved)] : null;
    if (!target || target === current) return;
    if (current) {
      current.classList.remove('is-current');
      current.removeAttribute('aria-current');
    }
    target.classList.add('is-current');
  }

  /* ───────── „Descarcă aplicația” (a cincea rundă, 04.10.2026) ───────── */

  /*
   * Zoli: „bagă și un pop-up când deschide cineva web-ul, dacă e pe mobil, înainte de pop-up-ul de adresă, cu descarcă
   * aplicația”. Pe iPhone și Android, la prima pagină a unei vizite, peste orice altă fereastră (și peste cea de adresă a
   * widgetului de livrare, care rămâne dedesubt până se închide asta). Nu pe coș și nici la comenzi: acolo omul e în
   * mijlocul unei treburi. „Continuă pe site” îl ascunde 3 zile, „Descarcă aplicația” 30. `?aplicatie=1` îl arată oricând.
   */
  var APP_IOS = 'https://apps.apple.com/ro/app/grocera/id6766567281';
  var APP_ANDROID = 'https://play.google.com/store/apps/details?id=ro.groceramarket.grocera2';
  // Pictograma aplicației din App Store (punga Grocera), 144 px, aici ca să nu mai fie o cerere.
  var APP_ICON = 'data:image/jpeg;base64,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';
  var DAY = 864e5;
  function appPopup() {
    var ua = navigator.userAgent || '';
    var ios = /iPhone|iPod/.test(ua) || (/iPad|Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
    var android = /Android/i.test(ua);
    var forced = /[?&]aplicatie=1(&|$)/.test(location.search);
    if (!forced) {
      if (!ios && !android) return;
      if (/^\/(cart|checkout|checkouts)(\/|$)/.test(location.pathname) || /[?&]view=comenzi(&|$)/.test(location.search)) return;
      var state = {};
      try {
        state = JSON.parse(localStorage.getItem('ga-aplicatie') || '{}') || {};
      } catch (error) {
        state = {};
      }
      var now = Date.now();
      if (state.descarcat && now - state.descarcat < 30 * DAY) return;
      if (state.inchis && now - state.inchis < 3 * DAY) return;
      try {
        if (sessionStorage.getItem('ga-aplicatie')) return;
        sessionStorage.setItem('ga-aplicatie', '1');
      } catch (error) {}
    }
    var remember = function (key) {
      try {
        var saved = JSON.parse(localStorage.getItem('ga-aplicatie') || '{}') || {};
        saved[key] = Date.now();
        localStorage.setItem('ga-aplicatie', JSON.stringify(saved));
      } catch (error) {}
    };
    var store = android ? APP_ANDROID : APP_IOS;
    var box = document.createElement('div');
    box.className = 'ga-app';
    box.style.setProperty('--ga-app-icon', 'url("' + APP_ICON + '")');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-labelledby', 'GaAppTitlu');
    box.innerHTML =
      '<div class="ga-app__fundal" data-ga-app-inchide></div>' +
      '<div class="ga-app__foaie">' +
      '<span class="ga-app__maner" aria-hidden="true"></span>' +
      '<span class="ga-app__iconita" aria-hidden="true"></span>' +
      '<p class="ga-app__titlu" id="GaAppTitlu">Grocera e mai simplă în aplicație</p>' +
      '<p class="ga-app__text">Comanzi din câteva atingeri, urmărești curierul pe hartă și afli pe loc când ajunge comanda.</p>' +
      '<a class="ga-app__descarca" href="' + store + '" rel="noopener">Descarcă aplicația</a>' +
      '<button type="button" class="ga-app__site" data-ga-app-inchide>Continuă pe site</button>' +
      '</div>';
    var close = function () {
      box.classList.remove('is-open');
      root.classList.remove('ga-app-deschis');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () {
        if (box.parentNode) box.parentNode.removeChild(box);
      }, 260);
    };
    var onKey = function (event) {
      if (event.key === 'Escape') {
        remember('inchis');
        close();
      }
    };
    box.addEventListener('click', function (event) {
      if (event.target.closest('[data-ga-app-inchide]')) {
        event.preventDefault();
        remember('inchis');
        close();
      } else if (event.target.closest('.ga-app__descarca')) {
        remember('descarcat');
        setTimeout(close, 400);
      }
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(box);
    root.classList.add('ga-app-deschis');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        box.classList.add('is-open');
      });
    });
  }

  ready(function () {
    topbar();
    if (phone.matches) {
      productSheet();
      originTab();
      try {
        appPopup();
      } catch (error) {
        if (window.console) console.warn('[ga] aplicatia', error);
      }
      raion();
      squareImages();
      searchPlaceholder();
      product();
      cart();
    }
    watchPreview();
    if (document.body) new MutationObserver(watchPreview).observe(document.body, { childList: true });
    window.addEventListener('resize', previewLift);
  });
})();
